export class BaseEntityModalPayload {
  entityId: number;
}
